import { render, staticRenderFns } from "./MmodelsCreate.vue?vue&type=template&id=9d046df2&scoped=true"
import script from "./MmodelsCreate.vue?vue&type=script&lang=js"
export * from "./MmodelsCreate.vue?vue&type=script&lang=js"
import style0 from "./MmodelsCreate.vue?vue&type=style&index=0&id=9d046df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d046df2",
  null
  
)

export default component.exports